import { useSelector } from "react-redux"
import { State } from "../../../../reducers"
import { getLogoEmpresa } from "../../../../actions/operaciones/operaciones.actions"
import { useEffect, useState } from "react"
import InputForm from "../InputFormV2"
import { Pagination } from "../../../../components/Pagination"
import useNotaRemision from "../../../../actions/nota-remision.actions"
import { getFechaCA } from "../../../../utils/stringDate"
import { unirChipsJoin, unirChipsReturnFirst } from "../../../../utils/strings.utils"
import { processDetalleImpuestosHTML } from "../../../../actions/utils-documentos.actions"
import FilaDistritoDTE from "../CamposV2/FilaDistritoDTE";
import {TIPO_DTE, versionDteEmision} from '../../../../utils/version-documento.utils'

import FilaDistritoEmisor from "../CamposV2/FilaDistritoEmisor";
import {montosDeProducto} from '../../../../utils/calculo-otros-documentos'
export default function DTENotaRemsion (){
    const {formCliente, productos, response_QRcode, view, documentosAsociados,mostrarDetalle, tableProductos} = useSelector((state: State) => state.notaRemision )
    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const {datosEmisor, tipoDocumento, actividadesEconomicas, municipios, departamentos, tipoDocumentosEmision, unidadesMedida, productos: productosCatalogo} = useSelector((state: State) => state.catalogos)
    const {datos} = useSelector((state: State) => state.userLogin)
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form)
    const sucursal = formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente.sucursal)?.nombre
    const documento = formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente.sucursal)?.Documento?.find((doc: any) => doc.idsucursaldocumento === formCliente.serie)
    const serie = `${documento?.serie}-${documento?.numeroactual}`

    const {button_mostrarDetalle, setTableProductos, totalesDocumento} = useNotaRemision()

    const totales = totalesDocumento()
    
    useEffect(() => {
        setTableProductos(productos)
    }, [productos, mostrarDetalle])


    return (
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout w-100' >
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell w-100' >
        <div className="card">
            <div className="dte-title">
                <label>{view === 'Previsualizacion' ? 'PREVISUALIZACIÓN DE ' : '' }DOCUMENTO TRIBUTARIO ELECTRÓNICO</label>
                <label>NOTA DE REMISIÓN</label>
            </div>
            <div className="separador" />
            <div className='dt-card-grid-2c-1r' style={{alignItems: 'center'}}>
                <div className='dt-card-2c-1r-no-border' style={{textAlign: 'center'}}>
                    <img alt="Logo" src={getLogoEmpresa()} className='logo-itprofis'/>
                </div>
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                    <table className="dte-table">
                        <tr>
                            <td>Documento Tributario Electrónico Versión:</td>
                            <td>{versionDteEmision(TIPO_DTE.NOTA_REMISION, datosEmisor) || ''}</td>
                        </tr>
                        <tr>
                            <td>Código de Generación:</td>
                            <td>{datosUUID?.CodigoGeneracion}</td>
                        </tr>
                        <tr>
                            <td>Sucursal:</td>
                            <td>{sucursal}</td>
                        </tr>
                        <tr>
                            <td>Serie:</td>
                            <td>{serie}</td>
                        </tr>
                        <tr>
                            <td>Moneda:</td>
                            <td>USD - Dólar estadounidense</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div className='dt-card-grid-2c-1r'>
                {/* DATOS DEL RECEPTOR */}
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                <div className='dt-center-content'>
                    <label className="dte-subsection-title">Receptor</label>
                    <table className="dte-table">
                        <tr><td>Nombre:</td><td>{formCliente?.nombre}</td></tr>
                        <tr><td>NIT:</td><td>{formCliente?.noDocumento}</td></tr>
                        <tr><td>NRC:</td><td>{formCliente?.nrc}</td></tr>
                        <tr><td>Actividad económica:</td><td>{actividadesEconomicas.find((actividad) => actividad.codigo === formCliente?.actividad)?.valor}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{formCliente?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{unirChipsReturnFirst(formCliente?.chipsEmail, formCliente?.email)}</td></tr>
                        <tr><td>Dirección:</td><td>{formCliente?.direccion}</td></tr>
                        <tr><td>Departamento:</td><td>{departamentos.find((departamento) => departamento.codigo === formCliente?.departamento)?.valor?.toUpperCase() }</td></tr>
                        <tr><td>Municipio:</td><td>{municipios.find((municipio) => municipio.codigo === formCliente?.municipio)?.valor?.toUpperCase() }</td></tr>
                        <FilaDistritoDTE distrito = {formCliente?.distrito}/>
                        <tr><td>Envío de documento por correo electrónico a:</td><td>{unirChipsJoin(formCliente?.chipsEmail, formCliente?.email)}</td></tr>
                    </table>
                </div>
                </div>
                {/* DATOS DEL EMISOR */}
                <div className='dt-card-2c-1r' style={{padding:"3% 0"}}>
                    <div className='dt-center-content'>
                    <label className="dte-subsection-title">Emisor</label>
                    <table className="dte-table">
                        <tr><td>Tipo de persona:</td><td>{datosEmisor?.desTipoEmpresa ?? ''}</td></tr>
                        <tr><td>Tipo de contribuyente:</td><td>{datosEmisor?.desContribuyente ?? ''}</td></tr>
                        <tr><td>Nombre del cliente:</td><td>{datosEmisor?.nombre}</td></tr>
                        <tr><td>Dirección:</td><td>{datosEmisor?.complemento}</td></tr>
                        <tr><td>Departamento:</td><td>{datosEmisor?.departamentonombre}</td></tr>
                        <tr><td>Municipio:</td><td>{datosEmisor?.municipionombre}</td></tr>
                        <FilaDistritoEmisor />
                        <tr><td>Giro:</td><td>{datosEmisor?.descactividad}</td></tr>
                        <tr><td>NIT:</td><td>{datosEmisor?.nit}</td></tr>
                        <tr><td>NRC:</td><td>{datosEmisor?.nrc}</td></tr>
                        <tr><td>Teléfono celular:</td><td>{datosEmisor?.telefono}</td></tr>
                        <tr><td>Correo electrónico:</td><td>{datosEmisor?.correo}</td></tr>
                    </table>
                </div>
                </div>
            </div>
            {documentosAsociados.length > 0 &&
            <div className="dte-section">
                <div className="dte-subsection">
                    <label className="dte-subsection-title">Documentos asociados</label>
                    <div className="tab-plane">
                        <table className="table-main-responsive responsive-table-main td-left table-pointer">
                            <thead>
                                <tr>
                                    <td style={{textAlign: 'left'}}>Correlativo</td>
                                    <td style={{textAlign: 'left'}}>Tipo de documento</td>
                                    <td style={{textAlign: 'left'}}>Emisión</td>
                                </tr>
                            </thead>
                            {documentosAsociados.map((documento, index) => (
                                <tr key={index}>
                                    <td data-label="Correlativo" style={{textAlign: 'left'}}>{documento?.numeroControl}</td>
                                    <td data-label="Tipo de documento" style={{textAlign: 'left'}}>{tipoDocumentosEmision?.find((tipo) => tipo.codigodocumento === documento?.tipoDocumento)?.nombre}</td>
                                    <td data-label="Emisión" style={{textAlign: 'left'}}>{ documento?.fisico === true ? getFechaCA(documento?.fechaEmision)  : `${documento.fechaEmision.split(' ')[0].split('-')[2]}/${documento.fechaEmision.split(' ')[0].split('-')[1]}/${documento.fechaEmision.split(' ')[0].split('-')[0]} ${(documento?.fechaEmision?.split(' ')[1]) || ''}`}</td>
                                </tr>
                            ))}
                        </table>
                    </div>
                </div>
            </div>
            }
            <div className="tab-plane" style={{marginTop:"25px"}}>
                <div className="table-facturacion-resp">
                    <table className="table-main-responsive responsive-table-main td-left table-pointer">
                        <thead>
                            <tr>
                                {documentosAsociados.length > 0 &&
                                <td>Numero de documento</td>
                                }
                                <td>Cantidad</td>
                                <td>Unidad de medida</td>
                                <td>Tipo</td>
                                <td>Descripción</td>
                                <td style={{display: mostrarDetalle ? '' : 'none'}}>Precio unitario</td>
                                <td style={{display: mostrarDetalle ? '' : 'none'}}>Otros impuestos</td>
                                <td style={{display: mostrarDetalle ? '' : 'none'}}>Descuento</td>
                                <td style={{display: mostrarDetalle ? '' : 'none'}}>Ventas gravadas</td>
                                <td style={{display: mostrarDetalle ? '' : 'none'}}>Ventas exentas</td>
                            </tr>
                        </thead>
                        <tbody>
                        {tableProductos.map((producto, index) => {
                                const {precioUni: precioUnitario, descuento, venta} = montosDeProducto(producto)
                                const detalleTributos = processDetalleImpuestosHTML(productosCatalogo, '04', producto, venta);

                                return(
                                <tr key={index}>
                                    {documentosAsociados.length > 0 &&
                                    <td data-label="Numero de documento">{producto.documentoAsociado}</td>
                                    }
                                    <td data-label="Cantidad">{producto.cantidad}</td>
                                    <td data-label="Unidad de medida">{unidadesMedida.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor}</td>
                                    <td data-label="Tipo">{`${producto.servicio ? 'Servicio' : 'Producto'} ${producto.exento ? ' exento' : ''}`}</td>
                                    <td data-label="Descripción" style={{wordBreak:"break-all"}}>{<div dangerouslySetInnerHTML={{ __html: producto.descripcion }} />}</td>
                                    {mostrarDetalle &&
                                    <>
                                        <td data-label="Precio unitario">{precioUnitario.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        <td data-label="Otros impuestos"><div dangerouslySetInnerHTML={{ __html: detalleTributos }} /></td>
                                        <td data-label="Descuento">{descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        <td data-label="Ventas gravadas">{!producto.exento ? venta.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}): '$0.00'}</td>
                                        <td data-label="Ventas exentas">{producto.exento ? venta.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}): '$0.00'}</td>
                                    </>
                                    }
                                </tr>
                            )})}
                        </tbody>
                    </table>
                </div>
                    <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                    {mostrarDetalle &&
                    <>

                        <div className="cf-calculos-producto">
                            <table>
                                <tbody>
                                    <tr className="cf-subtotal">
                                        <td>Suma de operaciones</td>
                                        <td>{totales.sumaOperaciones.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Impuesto al Valor Agregado 13%</td>
                                        <td>{totales.iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Otros impuestos</td>
                                        <td>{totales.otrosImpuestos.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Subtotal</td>
                                        <td>{totales.subtotal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>IVA percibido 1%</td>
                                        <td>{totales.ivaPercibido.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>IVA retenido 1%</td>
                                        <td>{totales.ivaRetenido.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-descuento">
                                        <td>Retencion renta 10%</td>
                                        <td>{totales.retencionRenta.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-total">
                                        <td>Total</td>
                                        <td>{totales.total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </>
                    }
            </div>
            <button style={{margin:"3% auto", width: "auto"}} className={`button ${mostrarDetalle && 'transparent'}`} onClick={() => button_mostrarDetalle(!mostrarDetalle)} >{mostrarDetalle ? 'Ocultar detalle' : 'Mostrar detalle'}</button>
            <div className='dt-card w-100 text-center' style={{padding: 0}}>
            {response_QRcode ? <div className='dt-card-grid-3c'>
              {response_QRcode && <div>
                <img src={response_QRcode} alt='qr' className='dt-img-qr'/>
              </div>}
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : formCliente?.nombre}</label>
                </div>
              </div>
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>{`${datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}` : tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : formCliente?.noDocumento}</label>
                </div>
              </div>
            </div> :
            <div className={'dt-card-grid-2c'}>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                <label>{datosReceptor.nombre ? datosReceptor.nombre : formCliente?.nombre}</label>
                </div>
                <div className='detail'>
                  <label>{`${datosReceptor.nombreTipoDocumento ? `${datosReceptor.nombreTipoDocumento}` : tipoDocumento.find((doc) => doc.codigo === formCliente.tipoDocumento)?.valor}:`}</label>
                  <label>{datosReceptor.nombreTipoDocumento ? datosReceptor.numId : formCliente?.noDocumento}</label>
                </div>
            </div> }
            </div>
        </div>
        </div>
        </div>
    )
}